import { ArrayHelpers, Loading, Modal, SystemText, Table } from 'e4shared';
import { translateCourse } from 'helpers/translations';
import React from 'react';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';

export const Modules = ({ show, onClose }) => {
    const [loading, setLoading] = React.useState(false);
    const [descending, setDescending] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [data, setData] = React.useState([]);
    const [sortedData, setSortedData] = React.useState([]);

    const { user } = useSelector(state => state.user);

    const pageSize = 15;

    React.useEffect(() => {
        if (show?.id) {
            setLoading(true);
            apiGet(`modules-by-competency/${show.id}`, user.guid, response => {
                setData(response.map(x => translateCourse(user.languageCode, x)));
                setLoading(false);
            });
        }
    }, [show?.id]);

    React.useEffect(() => {
        if (data?.length) {
            const d = descending ? -1 : 1;
            setSortedData(
                ArrayHelpers.getPage(
                    data.sort((a, b) => (a.title > b.title ? 1 * d : -1 * d)),
                    page,
                    pageSize
                )
            );
        }
    }, [data, page, descending]);

    const columns = [
        {
            label: SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Content/Modal/Table'),
            format: (value, row) => (
                <a className="btn btn-link flex flex-center" href={row.url} target="_blank">
                    <span className="mr5">{row.title}</span>
                    <i className="fa fa-new-window" />
                </a>
            ),
        },
    ];

    const options = {
        page,
        pageSize: pageSize,
        recordCount: data.length,
    };

    return (
        <Modal
            show={show}
            title={SystemText('Dashboard/Widgets/ActionPlanner/Table/Columns/Content/Modal/Title', show?.name)}
            footer={null}
            close={onClose}
        >
            {loading ? (
                <Loading />
            ) : (
                <Table
                    data={sortedData}
                    columns={columns}
                    options={options}
                    sort={() => setDescending(!descending)}
                    goToPage={setPage}
                />
            )}
        </Modal>
    );
};

export default Modules;
